import { render } from "./CreatePaymentModal.vue?vue&type=template&id=4be96984&scoped=true"
import script from "./CreatePaymentModal.vue?vue&type=script&lang=js"
export * from "./CreatePaymentModal.vue?vue&type=script&lang=js"

import "./CreatePaymentModal.vue?vue&type=style&index=0&id=4be96984&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be96984"]])

export default __exports__